import api from "assets/js/public.js";
export default {
  data() {
    return {
      detail: {}
    };
  },
  created() {
    // @ts-ignore
    api.postionDetail({
      unid: this.$route.query.id
    }).then(res => {
      this.detail = res.data;
    });
  }
};